import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'react-loader-spinner';

const CentsLoader = ({ height = 80, width = 80 }) => {
  return <Loader type="BallTriangle" color="#3d98ff" height={height} width={width} />;
};

CentsLoader.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default CentsLoader;
